import { createFileRoute } from '@tanstack/react-router';
import { SecuritySettingsPage } from '../../components/settings/settings-shell.js';

export const Route = createFileRoute('/settings/security')({
  component: SecuritySettingsPage,
});
